import type { LegacyCardAvatarSource } from '../types/legacy-conversation-card.type';

/**
 * Selects a name or address-derived initials for a legacy conversation avatar.
 * @param source - Contact name and fallback address.
 * @returns Text from which the shared avatar derives initials.
 */
export const getLegacyCardAvatarText = ({
  fullName,
  fallbackValue,
}: LegacyCardAvatarSource) => {
  if (fullName) {
    return fullName;
  }

  const alphanumericFallback = fallbackValue.replace(/[^a-zA-Z0-9]/g, '');

  if (alphanumericFallback.length >= 2) {
    return `${alphanumericFallback[0]} ${alphanumericFallback[1]}`;
  }

  if (alphanumericFallback.length === 1) {
    return alphanumericFallback;
  }

  return fallbackValue || '?';
};
